import { Injectable, Injector } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, EMPTY, Observable } from 'rxjs';
import { USER_AUTHENTICATION_SERVICE } from '../services/user-auth.interface';
import { StoreStateService } from '../services/store-state.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private readonly router: Router, private readonly storeState: StoreStateService, private readonly injector: Injector) {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const auth = this.injector.get(USER_AUTHENTICATION_SERVICE);
    const user = auth.authenticatedUser;
    const headers: Record<string, string> = {};
    if (user?.token) headers['Authorization'] = `Bearer ${user.token}`;
    if (this.storeState.storeId) headers['StoreId'] = String(this.storeState.storeId);
    const authorizedRequest = Object.keys(headers).length ? request.clone({ setHeaders: headers }) : request;
    return next.handle(authorizedRequest).pipe(catchError((error: HttpErrorResponse) => {
      if (error.status === 401) { auth.clearSession(); this.storeState.clearStore(); void this.router.navigate(['/account/login']); return EMPTY; }
      throw error;
    }));
  }
}
